import { alpha, Stack, styled, Typography } from '@mui/material';

export const StyledContainer = styled(Stack)(({ theme }) => ({
  cursor: 'pointer',
  width: theme.spacing(25),
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '1px',
  borderRadius: theme.spacing(1),
  background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const StyledGlassBox = styled(Stack)(({ theme }) => ({
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(1),
  background: alpha(theme.palette.grey[900], 0.62),
  borderRadius: theme.spacing(1),
  gap: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    background: theme.palette.grey[900],
  },
  '& svg': {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
}));

export const StyledTypography = styled(Typography)({
  fontSize: '12px',
});
